import {capitalize} from 'lodash';
import translate from '@/utils/translate';

export const APPROVAL_STEPS = ['brand', 'agency', 'legal', 'pr'] as const;

export const APPROVAL_STEP_LABELS: Record<string, string> = {
  brand: 'Brand',
  agency: 'Agency',
  legal: 'Legal',
  pr: 'PR',
};

export function getApprovalStepDisplayName(step: string): string {
  return translate(APPROVAL_STEP_LABELS[step] ?? capitalize(step));
}
